module.exports = {"unspecified":"Non spécifié","horde":"Horde","alliance":"Alliance"};